var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.auth && _vm.status
    ? _c(
        "div",
        { staticClass: "issuer" },
        [
          _c(
            "span",
            { staticClass: "issuer__btn", on: { click: _vm.openModal } },
            [_vm._v("Сообщения эмитента")]
          ),
          _vm._v(" "),
          _vm.link
            ? _c(
                "a",
                {
                  staticClass: "issuer__link",
                  attrs: { href: _vm.link, target: "_blank" },
                },
                [
                  _c("i", {
                    staticClass: "fas fa-external-link-alt",
                    attrs: { title: "Страница эмитента" },
                  }),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isModal
            ? _c("issuer-modal", {
                attrs: { ogrn: _vm.ogrn },
                on: { close: _vm.closeModal },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }